import { capitalize } from 'lodash';
import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import InitiativeFormContainer from '../../containers/initiatives/InitiativeFormContainer.jsx';

const NewInitiative = ({ projectId, initiativeType, slug }) => {
  const title = `Add ${capitalize(initiativeType)}`;

  return (
    <>
      <Helmet>
        <title>{title} | ChangeSync</title>
      </Helmet>
      <InitiativeFormContainer
        title={title}
        projectId={projectId}
        initiativeType={initiativeType}
        query={{}}
        slug={slug}
      />
    </>
  );
};

NewInitiative.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  initiativeType: query.initiativeType,
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewInitiative));
